// NOTE(sylvain): Need to stay in sync with server code, MEH...
export enum PeerType {
	USER = "user",
	HOLOLENS = "hololens",
	LARGE_DISPLAY = "large-display",
}
